import React from 'react';

import logo from 'assets/img/logo-white.png';

function Logo() {
  return <img width="100%" height="50px" style={{ objectFit: 'contain' }} src={logo} alt="SL Diamonds" />;
}

export default Logo;
